import { render, staticRenderFns } from "./PersonMedia.vue?vue&type=template&id=505ee249&scoped=true"
import script from "./PersonMedia.vue?vue&type=script&lang=js"
export * from "./PersonMedia.vue?vue&type=script&lang=js"
import style0 from "./PersonMedia.vue?vue&type=style&index=0&id=505ee249&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ee249",
  null
  
)

export default component.exports